<template>
    <div id="navigation" class="navigation" ref="navigation">
        <div class="navigation-bg"></div>
        <div class="nav__logo__btn">
            <router-link  @click="toggleNav = false" :to="{name: 'section', params:{sectionSlug: root.slug}}"><img src="/images/ashenden-logo.svg" alt="Logo"></router-link>
            <div class="hamburger-wrapper">
                <span>menu</span>
                <button class="hamburger hamburger--collapse hamburger--stand" type="button" @click="toggleNav = !toggleNav" :class="{'is-active': toggleNav}">
                    <span class="hamburger-box">
                        <span class="hamburger-inner"></span>
                    </span>
                </button>                
            </div>
        </div>
        <div class="nav-wrapper" :class="{'is-active': toggleNav}">
            <ul>
                <li v-for="section in sections" :key="section.id" v-if="section.type != 'root' && section.type != 'footer'" @click.prevent="toggleNav = false">
                    <router-link :to="{ name: 'section', params: { sectionSlug: section.slug }}">{{section.title}}</router-link>
                </li>
            </ul>
            <div class="languages">
				<a href="#" :class="{'active': $route.params.locale === 'en'}" @click.prevent="changeLanguage('en')">eng</a>
                <a href="#" :class="{'active': $route.params.locale === 'fr'}" @click.prevent="changeLanguage('fr')">fr</a>
            </div>
            <div class="socials hidden-desktop">
                <a target="_blank" href="https://twitter.com/AshendenFinance"><i class="icon-twitter"></i></a>
                <a target="_blank" href="https://www.youtube.com/channel/UCGzIiUFBLUfw0KfQi8VfXVw"><i class="icon-youtube-play"></i></a>
                <a target="_blank" href="https://www.linkedin.com/company/ashenden-finance-sa/"><i class="icon-linkedin"></i></a>
            </div>
        </div>
        <div class="socials hidden-mobile">
            <a target="_blank" href="https://twitter.com/AshendenFinance"><i class="icon-twitter"></i></a>
            <a target="_blank" href="https://www.youtube.com/channel/UCGzIiUFBLUfw0KfQi8VfXVw"><i class="icon-youtube-play"></i></a>
            <a target="_blank" href="https://www.linkedin.com/company/ashenden-finance-sa/"><i class="icon-linkedin"></i></a>
            
        </div>
    </div>
</template>

<script>
    import _find from 'lodash/find'
    export default {
        props: ['sections'],
        created: function () {
        },
        mounted: function () {
            var tl = new TimelineMax()
            let nav = this.$refs.navigation

            tl
                .set(nav,{opacity: 0})
                .to(nav, 1, {opacity: 1}, 0.2)
                
            this.animations()
        },
        watch: {
            'toggleNav': function(newVal, oldVal) {
                var body = document.querySelector('body')
                if(newVal) {
                    body.classList.add('overflow-hidden')
                } else {
                    body.classList.remove('overflow-hidden')
                }
            }
        },        
        data () {
            return {
                toggleNav: false
            }
        },
        methods: {
            changeLanguage (lang) {
                if (lang !== this.$route.params.locale) {
                    document.querySelector('body').style.opacity = 0
                    switch (lang) {
                        case 'en':
                            this.$router.push({ name: 'section', params: { locale: lang, sectionSlug: 'home' }})
                            window.location.reload();
                            break;
                        case 'fr':
                            this.$router.push({ name: 'section', params: { locale: lang, sectionSlug: 'accueil' }})
                            window.location.reload();
                            break;
                    }
                }
            },
            animations() {
                let timeL = new TimelineLite;
                timeL
                    .fromTo('.nav__logo__btn', .7, {scale: .7}, {scale: 1, ease:Back.easeOut})
                    .staggerFromTo('.nav-wrapper li', 0.7, {opacity:0, x: -60, ease:Back.easeOut}, {opacity:1, x: 0}, .1)
                    .staggerFromTo('.socials a', 0.7, {opacity:0, y: -30, ease:Back.easeOut}, {opacity:1, y: 0})
            }
        },
        computed: {
            root() {
                return _find(this.sections, {type: 'root'})
            }
        }
    }
</script>